export default __webpack_public_path__ + "static/raven-0d04cc5c34d73fbeea41fc5600958923.svg";